import { render, staticRenderFns } from "./fee_modal.vue?vue&type=template&id=08eb4afb&scoped=true&"
import script from "./fee_modal.vue?vue&type=script&lang=js&"
export * from "./fee_modal.vue?vue&type=script&lang=js&"
import style0 from "./fee_modal.vue?vue&type=style&index=0&id=08eb4afb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eb4afb",
  null
  
)

export default component.exports